<template>
  <div class="result-container">
    <div class="content-box">
      <div class="row content-header">
        <div class="row">
          <div>{{searchText}}</div>
          <span class="attention-btn add-attention-btn row" v-if="!existed" @click="isSelectCategory=true">加关注</span>
          <span class="attention-btn delete-attention-btn" v-if="existed" @click="dialogVisible=true">已关注</span>
        </div>
        <span
          v-if="isMonitored"
          class="edit-notification-icon-bg"
          :class="{'alarm-bg':alarmStatus}"
        >
          <entity-alarm-stand-alone-setting
            class="edit-notification-icon"
            :class="{'alarm':alarmStatus}"
            @entityAlarmStatus="entityAlarmStatus"
            :search-text="searchText"
          ></entity-alarm-stand-alone-setting>
        </span>
      </div>
      <div class="company-name" v-if="stockCode">{{stockCode}}</div>
      <div class="content-body">
        <sentiment-trends @checkedDate="checkedDate" :search-text="searchText"></sentiment-trends>
        <div class="row section clearfix">
          <div class="left">
            <div class="row header-tab">
              <div class="row">
                <div
                  class="tab-item"
                  :class="{'tab-item-active': item.name === selectedOptionTab}"
                  v-for="item in headerTabs"
                  :key="item.name"
                  @click="onTabClick(item)"
                >{{ item.name }}</div>
              </div>
            </div>
            <div v-show="selectedOptionTab === '公司舆情'">
              <div class="row news-type-tab">
                <el-button
                  class="news-type-tab-btn"
                  :class="{'news-type-tab-active': item === selectedCompanyTab}"
                  v-for="(item, index) in dateRangeTabs"
                  :key="index"
                  @click="onSecondTabClick(item)"
                >{{item}}</el-button>
              </div>
              <div class="company-event-list" v-show="selectedCompanyTab === '事件'">
                <div v-loading="isLoading">
                  <div
                    v-infinite-scroll="loadMoreCompanyEvent"
                    infinite-scroll-disabled="companyEventBusy"
                    infinite-scroll-distance="10"
                  >
                    <company-event-list
                      v-for="(item, index) in companyEventData"
                      :key="index"
                      :data="item"
                    ></company-event-list>
                  </div>
                </div>
                <div class="event-loading" v-if="companyEventItemData.length && companyEventData.length">
                  <div class="loading-word">加载中...</div>
                </div>
                <div class="event-loading" v-if="!companyEventItemData.length && companyEventData.length">
                  <div class="loading-word">没有更多了</div>
                </div>
              </div>
              <div class="company-news-list" v-show="selectedCompanyTab === '新闻'">
                <div class="company-news-list-header">
                  <CriteriaSearchArea
                    class="criteria-search-area"
                    v-if="filterTag"
                    :filterTag="filterTag"
                    @checkedArr="checkedArr"
                  />
                  <div class="row news-list-source-filter" :class="{'has-criteria-search-area': filterTag && (filterTag.positive.length || filterTag.negative.length)}">
                    <div class="total-count">共有{{totalCount}}条相关新闻</div>
                    <div class="news-list-source-filter-right">
                      <SnDatePicker @timeChange="timeChange"></SnDatePicker>
                      <el-select
                        class="select set-vertical-align"
                        v-model="source"
                        @change="onSourceChange"
                        placeholder="来源"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-select
                        class="select set-vertical-align"
                        v-model="inewsImportanceLever"
                        @change="onInewsImportanceLeverChange"
                        placeholder="重要程度"
                      >
                        <el-option
                          v-for="item in inewsImportanceLeverOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-tooltip 
                        class="item" 
                        effect="dark" 
                        :content="cluesTip" 
                        :visible-arrow="false"
                        :enterable="false"
                        popper-class="clues-tip"
                        placement="bottom-start"
                      >
                        <el-button v-if="showClues" @click="showClues = false" class="clues-show-btn set-vertical-align"><img :src="require('../assets/img/clues.svg')" class="icon" alt=""></el-button>
                        <el-button v-else @click="showClues = true" class="clues-show-btn set-vertical-align"><img :src="require('../assets/img/clues.svg')" class="icon" alt=""></el-button>
                      </el-tooltip>
                    </div>

                    <div v-if="showCompanyNewsUnread && selectedCompanyTab === '新闻'" @click="onShowCompanyNewMessage" class="row company-news-unread-message">
                      <img src="../assets/img/arrow-up.svg" class="icon" alt="">
                      <span class="company-news-unread-count">{{latestCompanyNewsData.length}}条新闻</span>
                    </div>
                  </div>
                </div>
                <div class="company-result-news-list">
                  <div v-loading="isLoading">
                    <div
                      v-infinite-scroll="loadMore"
                      infinite-scroll-disabled="busy"
                      infinite-scroll-distance="30"
                    >
                      <news-list-item
                        v-for="(item, index) in resultData"
                        :key="index"
                        :data="item"
                        :showClues="showClues"
                      ></news-list-item>
                    </div>
                  </div>
                  <div class="loading" v-if="itemData.length && resultData.length && totalCount>pageSize">
                    <div class="loading-word">加载中...</div>
                  </div>
                  <div class="loading" v-if="!itemData.length && resultData.length || (totalCount>0 && totalCount<=pageSize)">
                    <div class="loading-word">没有更多了</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="selectedOptionTab === '周边舆情'">
              <div class="row news-type-tab">
                <el-button
                  class="news-type-tab-btn"
                  :class="{'news-type-tab-active': item === selectedPerimeterTab}"
                  v-for="(item, index) in perimeterNewsTabs"
                  :key="index"
                  @click="onSecondPerimeterTabClick(item)"
                >{{item}}</el-button>
              </div>
              <div class="company-event-list" v-show="selectedPerimeterTab==='事件'">
                <div v-loading="isLoading">
                  <div
                    v-infinite-scroll="loadMoreCompanyPerimeterEvent"
                    infinite-scroll-disabled="companyPerimeterEventBusy"
                    infinite-scroll-distance="10"
                  >
                    <company-event-list
                      v-for="(item, index) in companyPerimeterEventData"
                      :key="index"
                      :data="item"
                    ></company-event-list>
                  </div>
                </div>
                <div class="event-loading" v-if="companyPerimeterEventItemData.length && companyPerimeterEventData.length">
                  <div class="loading-word">加载中...</div>
                </div>
                <div class="event-loading" v-if="!companyPerimeterEventItemData.length && companyPerimeterEventData.length">
                  <div class="loading-word">没有更多了</div>
                </div>
              </div>
              <div class="company-news-list" v-show="selectedPerimeterTab==='新闻'">
                <div class="company-news-list-header">
                  <CriteriaSearchArea
                    class="criteria-search-area"
                    v-if="filterTag"
                    :filterTag="filterTag"
                    @checkedArr="checkedPerimeterArr"
                  />
                  <div class="row news-list-source-filter" :class="{'has-criteria-search-area': filterTag && (filterTag.positive.length || filterTag.negative.length)}">
                    <div class="total-count">共有{{perimeterTotalCount}}条相关新闻</div>
                    <div class="news-list-source-filter-right">
                      <SnDatePicker @timeChange="perimeterTimeChange"></SnDatePicker>
                      <el-select
                        class="select set-vertical-align"
                        v-model="perimeterSource"
                        @change="onPerimeterSourceChange"
                        placeholder="来源"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-select
                        class="select set-vertical-align"
                        v-model="perimeterInewsImportanceLever"
                        @change="onPerimeterInewsImportanceLeverChange"
                        placeholder="重要程度"
                      >
                        <el-option
                          v-for="item in inewsImportanceLeverOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-tooltip 
                        class="item" 
                        effect="dark" 
                        :content="PerimeterCluesTip" 
                        :visible-arrow="false"
                        :enterable="false"
                        popper-class="clues-tip"
                        placement="bottom-start"
                      >
                        <el-button v-if="showPerimeterClues" @click="showPerimeterClues = false" class="clues-show-btn set-vertical-align"><img :src="require('../assets/img/clues.svg')" alt=""></el-button>
                        <el-button v-else @click="showPerimeterClues = true" class="clues-show-btn set-vertical-align"><img :src="require('../assets/img/clues.svg')" alt=""></el-button>
                      </el-tooltip>
                    </div>

                    <div v-if="showPerimeterUnread && selectedPerimeterTab==='新闻'" @click="onShowPerimeterNewMessage" class="row company-news-unread-message">
                      <img src="../assets/img/arrow-up.svg" class="icon" alt="">
                      <span class="company-news-unread-count">{{latestPerimeterData.length}}条新闻</span>
                    </div>
                  </div>
                </div>
                
                <div class="perimeter-result-news-list">
                  <div v-loading="isLoading">
                    <div
                      v-infinite-scroll="loadMorePerimeter"
                      infinite-scroll-disabled="perimeterBusy"
                      infinite-scroll-distance="10"
                    >
                      <news-list-item
                        v-for="(item) in perimeterResultData"
                        :key="item.NewsId"
                        :data="item"
                        :showClues="showPerimeterClues"
                        :searchText="searchText"
                      ></news-list-item>
                    </div>
                  </div>
                  <div class="loading" v-if="perimeterItemData.length && perimeterResultData.length && perimeterTotalCount>pageSize">
                    <div class="loading-word">加载中...</div>
                  </div>
                  <div class="loading" v-if="!perimeterItemData.length && perimeterResultData.length || (perimeterTotalCount>0 && perimeterTotalCount<=pageSize)">
                    <div class="loading-word">没有更多了</div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="right">
            <div class="result-right-content">
              <entity-news-statistics :search-text="searchText"></entity-news-statistics>
              <perimeter-company :search-text="searchText" :stock-code="stockCode" class="perimeter-company"></perimeter-company>
            </div>
          </div>
        </div>
      </div>
    </div>
    <select-category v-if="isSelectCategory"
      :checkedTag="checkedTag" 
      @cancelOperation="cancelOperation"
      @continueTo="continueTo"
      @addGroup="addGroup"/>
    <NewGroup v-if="isAddShow" @closeAddGroup="closeAddGroup" />
    <BackTop></BackTop>
    <CompanyDateNewsDialog @closeTodayCompanyDialog="showTodayCompanyDialog = false" v-if="showTodayCompanyDialog" :searchText="searchText" :chartCheckedDate="chartCheckedDate"></CompanyDateNewsDialog>
    <el-dialog
      title="取消关注"
      class="delete-dialog"
      :visible.sync="dialogVisible"
      width="400px"
      top="33vh"
    >
      <div class="content">取消关注“{{ searchText }}”？</div>
      <div class="footer" slot="footer">
        <div class="footer-btn">
          <el-button class="cancel-btn" @click="cancel">取消</el-button>
          <el-button class="confirm-btn" @click="onOKDeleteBtnClick">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CompanyDateNewsDialog from '@/components/news-monitor/CompanyDateNewsDialog';
import EntityNewsStatistics from '@/components/news-monitor/EntityNewsStatistics';
import PerimeterCompany from '@/components/news-monitor/PerimeterCompany';
import SentimentTrends from '@/components/news-monitor/SentimentTrends';
import EntityAlarmStandAloneSetting from '@/components/news-monitor/EntityAlarmStandAloneSetting';
import BackTop from '@/components/common/BackTop';
import CompanyEventList from '@/components/company-detail/CompanyEventList';
import questionQuery from '@/rest/questionQuery';
import CriteriaSearchArea from '@/components/news-monitor/CriteriaSearchArea';
import NewsListItem from '@/components/news-monitor/NewsListItemV2';
import authService from '@/services/authService';
import SelectCategory from '@/components/common/SelectCategory';
import NewGroup from '@/components/common/NewGroup';
import SnDatePicker from '@/components/common/SnDatePicker';

export default {
  name: 'result-page',
  data() {
    return {
      inewsImportanceLever: '重要程度',
      inewsImportanceLeverData: [],
      perimeterInewsImportanceLever: '重要程度',
      perimeterInewsImportanceLeverData: [],
      inewsImportanceLeverOptions: [
        {
          value: '不限',
          label: '不限'
        },
        {
          value: '重要新闻',
          label: '重要新闻'
        },
        {
          value: '次要新闻',
          label: '次要新闻'
        },
        {
          value: '普通新闻',
          label: '普通新闻'
        }
      ],
      tagType: 'company',
      companyPerimeterEventTimer: null,
      companyPerimeterEventItemData: [],
      companyPerimeterEventBusy: false,
      companyEventTimer: null,
      companyEventItemData: [],
      companyEventBusy: false,
      eventId: -1,
      eventPageSize: 30,
      eventPageNum: 1,
      perimeterEventId: -1,
      perimeterEventPageSize: 30,
      perimeterEventPageNum: 1,
      hasPerimeterNews: true,
      hasNews: true,
      hasCompanyPerimeterEvent: true,
      hasCompanyEvent: true,
      latestCompanyNewsTimer: null,
      latestCompanyNewsData: [],
      showCompanyNewsUnread: false,
      companyNewsDoc: null,
      latestPerimeterTimer: null,
      latestPerimeterData: [],
      showPerimeterUnread: false,
      perimeterNewsDoc: null,
      topPerimeterNewsTimer: null,
      perimeterTimer: null,
      perimeterItemData: [],
      perimeterResultData: [],
      perimeterBusy: false,
      perimeterPageNum: 1,
      earliestPerimeterNewsId: -1,
      earliestPerimeterDateNum: -1,
      latestPerimeterDateNum: -1,
      perimeterSource: '全部来源',
      showPerimeterClues: true,
      perimeterTotalCount: 0,
      companyPerimeterEventData: [],
      isSelectCategory: false,
      latestNewsTimer: null,
      pageSize: 20,
      pageNum: 1,
      earliestNewsId: -1,
      earliestDateNum: -1,
      latestDateNum: -1,
      resultData: [],
      itemData: [],
      busy: false,
      timer: null,
      isLoading: false,
      dialogVisible: false,
      source: '全部来源',
      options: [
        {
          value: '全部来源',
          label: '全部来源'
        },
        {
          value: '官媒',
          label: '官媒'
        },
        {
          value: '公众号',
          label: '公众号'
        }
      ],
      showClues: true,
      totalCount: 0,
      negative: [],
      positive: [],
      filterTag: null,
      companyEventData: [],
      searchText: '',
      dateValue: [],
      companyName: '',
      alarmStatus: false,
      isMonitored: false,
      valueTag: [],
      stockCode: '',
      resultRightContent: null,
      dateRangeTabs: ['新闻', '事件'],
      perimeterNewsTabs: ['新闻', '事件'],
      selectedCompanyTab: '新闻',
      selectedPerimeterTab: '新闻',
      selectedOptionTab: '公司舆情',
      headerTabs: [
        {
          name: '公司舆情',
          path: '/result'
        },
        {
          name: '周边舆情',
          path: '/result'
        }
      ],
      username: '',
      existed: false,
      isAddShow: false,
      checkedTag: [],
      dateRange: [],
      perimeterDateRange: [],
      chartCheckedDate: [],
      showTodayCompanyDialog: false
    };
  },
  computed: {
    cluesTip() {
      return this.showClues ? '隐藏线索' : '显示线索';
    },
    PerimeterCluesTip() {
      return this.showPerimeterClues ? '隐藏线索' : '显示线索';
    }
  },
  methods: {
    onInewsImportanceLeverChange(res) {
      this.getLatestNewsSetInterval(false);
      switch (res) {
        case '不限':
          this.inewsImportanceLever = '重要程度';
          this.inewsImportanceLeverData = [];
          break;
        case '重要新闻':
          this.inewsImportanceLeverData = ['高'];
          break;
        case '次要新闻':
          this.inewsImportanceLeverData = ['中'];
          break;
        case '普通新闻':
          this.inewsImportanceLeverData = ['低'];
          break;
        default:
          break;
      }
      this.itemData = [];
      this.resultData = [];
      this.pageNum = 1;
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.getFirstNewsListV2();
    },
    onPerimeterInewsImportanceLeverChange(res) {
      this.getLatestPerimeterNewsSetInterval(false);
      switch (res) {
        case '不限':
          this.perimeterInewsImportanceLever = '重要程度';
          this.perimeterInewsImportanceLeverData = [];
          break;
        case '重要新闻':
          this.perimeterInewsImportanceLeverData = ['高'];
          break;
        case '次要新闻':
          this.perimeterInewsImportanceLeverData = ['中'];
          break;
        case '普通新闻':
          this.perimeterInewsImportanceLeverData = ['低'];
          break;
        default:
          break;
      }
      this.perimeterPageNum = 1;
      this.earliestPerimeterNewsId = -1;
      this.earliestPerimeterDateNum = -1;
      this.latestPerimeterDateNum = -1;
      this.perimeterItemData = [];
      this.perimeterResultData = [];
      this.getFirstPerimeterNewsListV2();
    },
    checkedDate(res) {
      if (!res[0].data) {
        this.$message({
          message: '当天无新闻',
          duration: 1000
        });
      } else {
        this.showTodayCompanyDialog = true;
        this.chartCheckedDate = [res[0].name, res[0].name];
      }
    },
    timeChange(date) {
      this.getLatestNewsSetInterval(false);
      this.dateRange = date || [];
      this.itemData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.getFirstNewsListV2();
    },
    perimeterTimeChange(date) {
      this.getLatestPerimeterNewsSetInterval(false);
      this.perimeterDateRange = date || [];
      this.perimeterPageNum = 1;
      this.earliestPerimeterNewsId = -1;
      this.earliestPerimeterDateNum = -1;
      this.latestPerimeterDateNum = -1;
      this.perimeterItemData = [];
      this.perimeterResultData = [];
      this.getFirstPerimeterNewsListV2();
    },
    cancelOperation() {
      this.checkedTag = [];
      this.isSelectCategory = false;
    },
    cancel() {
      this.dialogVisible = false;
    },
    onOKDeleteBtnClick() {
      questionQuery.deleteMonitor(this.username, this.searchText, []).then(
        () => {
          this.existed = false;
          this.dialogVisible = false;
        },
        () => {
          this.$message.error('取消关注失败！');
        }
      );
    },
    continueTo(tag = []) {
      this.isSelectCategory = false;
      questionQuery.addMonitorGroup(this.username, this.searchText, tag).then(
        () => {
          this.checkedTag = [];
          this.existed = true;
        },
        () => {
          this.$message.error('添加关注失败！');
        }
      );
    },
    closeAddGroup(value) {
      this.checkedTag = [].concat(value);
      this.isAddShow = false;
      this.isSelectCategory = true;
    },
    addGroup() {
      this.isSelectCategory = false;
      this.isAddShow = true;
    },
    onSourceChange(res) {
      this.getLatestNewsSetInterval(false);
      this.itemData = [];
      this.resultData = [];
      this.source = res;
      this.pageNum = 1;
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.getFirstNewsListV2();
    },
    onPerimeterSourceChange(res) {
      this.getLatestPerimeterNewsSetInterval(false);
      this.perimeterSource = res;
      this.perimeterPageNum = 1;
      this.earliestPerimeterNewsId = -1;
      this.earliestPerimeterDateNum = -1;
      this.latestPerimeterDateNum = -1;
      this.perimeterItemData = [];
      this.perimeterResultData = [];
      this.getFirstPerimeterNewsListV2();
    },
    onTabClick(res) {
      this.selectedOptionTab = res.name;
      if (this.selectedOptionTab === '公司舆情') {
        this.getLatestPerimeterNewsSetInterval(false);
        this.getLatestNewsSetInterval(false);
        this.$router.push({
          path: res.path,
          query: {
            q: this.$route.query.q,
            original: 'yes'
          }
        });
        this.selectedCompanyTab = this.hasNews ? '新闻' : '事件';
      } else {
        this.getLatestNewsSetInterval(false);
        this.getLatestPerimeterNewsSetInterval(false);
        this.$router.push({
          path: res.path,
          query: {
            type: 'perimeter',
            q: this.$route.query.q,
            original: 'yes'
          }
        });
        this.selectedPerimeterTab = this.hasPerimeterNews ? '新闻' : '事件';
      }
    },
    checkedArr({ negative, positive }) {
      this.getLatestNewsSetInterval(false);
      this.positive = positive;
      this.negative = negative;
      this.itemData = [];
      this.resultData = [];
      this.pageNum = 1;
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.getFirstNewsListV2();
    },
    checkedPerimeterArr({ negative, positive }) {
      this.getLatestPerimeterNewsSetInterval(false);
      this.positive = positive;
      this.negative = negative;
      this.perimeterPageNum = 1;
      this.earliestPerimeterNewsId = -1;
      this.earliestPerimeterDateNum = -1;
      this.latestPerimeterDateNum = -1;
      this.perimeterItemData = [];
      this.perimeterResultData = [];
      this.getFirstPerimeterNewsListV2();
    },
    getNewsListTag() {
      questionQuery.getNewsListTagV2(this.tagType, this.searchText).then(res => {
        // eslint-disable-next-line
        res.negative &&
          res.negative.forEach(v => {
            v.checkAll = false;
            if (v.options) {
              v.options.forEach(item => (item.checked = false));
            }
          });
        // eslint-disable-next-line
        res.positive &&
          res.positive.forEach(v => {
            v.checkAll = false;
            if (v.options) {
              v.options.forEach(item => (item.checked = false));
            }
          });
        this.filterTag = res;
      });
    },
    onSecondTabClick(res) {
      this.selectedCompanyTab = res;
      if (this.selectedCompanyTab === '新闻') {
        this.getLatestNewsSetInterval(false);
        this.filterTag = null;
        this.negative = [];
        this.positive = [];
        this.itemData = [];
        this.resultData = [];
        this.source = '全部来源';
        this.pageNum = 1;
        this.earliestNewsId = -1;
        this.earliestDateNum = -1;
        this.latestDateNum = -1;
        this.tagType = 'company';
        this.getNewsListTag();
        this.getFirstNewsListV2();
      } else {
        this.getLatestNewsSetInterval(false);
        this.companyEventData = [];
        this.companyEventItemData = [];
        this.eventPageNum = 1;
        this.eventId = -1;
        this.getCompanyEventList();
      }
    },
    onSecondPerimeterTabClick(res) {
      this.selectedPerimeterTab = res;
      if (this.selectedPerimeterTab === '新闻') {
        this.getLatestPerimeterNewsSetInterval(false);
        this.filterTag = null;
        this.negative = [];
        this.positive = [];
        this.perimeterSource = '全部来源';
        this.perimeterPageNum = 1;
        this.earliestPerimeterNewsId = -1;
        this.earliestPerimeterDateNum = -1;
        this.latestPerimeterDateNum = -1;
        this.perimeterItemData = [];
        this.perimeterResultData = [];
        this.tagType = 'related-company';
        this.getNewsListTag();
        this.getFirstPerimeterNewsListV2();
      } else {
        this.getLatestPerimeterNewsSetInterval(false);
        this.companyPerimeterEventData = [];
        this.companyPerimeterEventItemData = [];
        this.perimeterEventPageNum = 1;
        this.perimeterEventId = -1;
        this.getCompanyPerimeterEventList();
      }
    },
    monitorStatus(res) {
      this.isMonitored = res;
    },
    entityAlarmStatus(res) {
      this.alarmStatus = res;
    },
    interceptor(companyName) {
      this.companyName = companyName.companyName;
    },
    getStockCode() {
      questionQuery.getStockCode(this.searchText).then(res => {
        this.stockCode = res;
      });
    },
    loadMore() {
      this.busy = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.itemData.length) {
        this.timer = setTimeout(() => {
          this.getNewsListV2();
        }, 500);
      }
    },
    loadMorePerimeter() {
      this.perimeterBusy = true;
      if (this.perimeterTimer) {
        clearTimeout(this.perimeterTimer);
      }
      if (this.perimeterItemData.length) {
        this.perimeterTimer = setTimeout(() => {
          this.perimeterPageNum++;
          this.getPerimeterNewsListV2();
        }, 500);
      }
    },
    getLatestNewsListV2() {
      const params = {
        companies: [this.searchText],
        pageSize: 15,
        market: '全部',
        positive: this.positive,
        negative: this.negative,
        sourceGenre: this.source === '公众号' ? '微信' : this.source,
        earliestNewsId: -1,
        earliestDateNum: -1,
        latestDateNum: this.latestDateNum,
        company_importance_level: this.inewsImportanceLeverData.toString(),
        date: this.dateRange
      };
      questionQuery.getNewsListV2(params).then(
        res => {
          if (res.result.length) {
            this.latestDateNum = res.result[0].dateNum;
            if (this.companyNewsDoc.scrollTop >= 0 && this.companyNewsDoc.scrollTop <= 300) {
              this.showCompanyNewsUnread = false;
              this.companyNewsDoc.scrollTop = 0;
              this.resultData.unshift(...res.result);
            } else {
              this.showCompanyNewsUnread = true;
              this.latestCompanyNewsData = this.latestImportantNewsData.concat(res.result);
            }
          }
        },
        () => {
          this.getLatestNewsSetInterval(false);
        }
      );
    },
    onShowCompanyNewMessage() {
      this.showCompanyNewsUnread = false;
      this.resultData.unshift(...this.latestCompanyNewsData);
      this.latestCompanyNewsData = [];
      this.latestCompanyNewsTimer = setInterval(() => {
        if (this.companyNewsDoc.scrollTop) {
          this.companyNewsDoc.scrollTop = this.companyNewsDoc.scrollTop - 200;
        } else if (!this.companyNewsDoc.scrollTop || this.companyNewsDoc.scrollTop < 0) {
          clearInterval(this.latestCompanyNewsTimer);
        }
      }, 50);
    },
    getPerimeterNewsListV2() {
      const params = {
        companies: [this.searchText],
        pageSize: this.pageSize,
        market: '全部',
        positive: this.positive,
        negative: this.negative,
        sourceGenre: this.perimeterSource === '公众号' ? '微信' : this.perimeterSource,
        earliestNewsId: this.earliestPerimeterNewsId,
        earliestDateNum: this.earliestPerimeterDateNum,
        latestDateNum: -1,
        company_importance_level: this.perimeterInewsImportanceLeverData.toString(),
        date: this.perimeterDateRange,
        type: 'perimeter'
      };
      this.isLoading = true;
      questionQuery.getNewsListV2(params).then(res => {
        this.isLoading = false;
        this.perimeterItemData = res.result;
        this.perimeterTotalCount = res.totalCount;
        if (this.perimeterItemData.length) {
          this.earliestPerimeterNewsId = this.perimeterItemData[this.perimeterItemData.length - 1].newsId;
          this.earliestPerimeterDateNum = this.perimeterItemData[this.perimeterItemData.length - 1].dateNum;
          this.perimeterResultData = this.perimeterResultData.concat(this.perimeterItemData);
          this.perimeterBusy = false;
        } else {
          this.perimeterBusy = true;
        }
      });
    },
    getFirstPerimeterNewsListV2() {
      const params = {
        companies: [this.searchText],
        pageSize: this.pageSize,
        market: '全部',
        positive: this.positive,
        negative: this.negative,
        sourceGenre: this.perimeterSource === '公众号' ? '微信' : this.perimeterSource,
        earliestNewsId: this.earliestPerimeterNewsId,
        earliestDateNum: this.earliestPerimeterDateNum,
        latestDateNum: -1,
        company_importance_level: this.perimeterInewsImportanceLeverData.toString(),
        date: this.perimeterDateRange,
        type: 'perimeter'
      };
      this.isLoading = true;
      questionQuery.getNewsListV2(params).then(res => {
        this.isLoading = false;
        this.perimeterItemData = res.result;
        this.latestPerimeterDateNum = res.result[0].dateNum;
        this.perimeterTotalCount = res.totalCount;
        if (this.perimeterItemData.length) {
          this.earliestPerimeterNewsId = this.perimeterItemData[this.perimeterItemData.length - 1].newsId;
          this.earliestPerimeterDateNum = this.perimeterItemData[this.perimeterItemData.length - 1].dateNum;
          this.perimeterResultData = this.perimeterResultData.concat(this.perimeterItemData);
          this.perimeterBusy = false;
        } else {
          this.perimeterBusy = true;
        }
        this.getLatestPerimeterNewsSetInterval(true);
      });
    },
    getLatestPerimeterNewsSetInterval(start) {
      if (this.latestPerimeterTimer) {
        clearTimeout(this.latestPerimeterTimer);
      }
      if (start) {
        this.latestPerimeterTimer = setTimeout(() => {
          this.getLatestPerimeterNewsList();
          this.getLatestPerimeterNewsSetInterval(start);
        }, 1000 * 60);
      }
    },
    getLatestPerimeterNewsList() {
      const params = {
        companies: [this.searchText],
        pageSize: 15,
        market: '全部',
        positive: this.positive,
        negative: this.negative,
        sourceGenre: this.perimeterSource === '公众号' ? '微信' : this.perimeterSource,
        company_importance_level: this.perimeterInewsImportanceLeverData.toString(),
        earliestNewsId: -1,
        earliestDateNum: -1,
        latestDateNum: this.latestPerimeterDateNum,
        type: 'perimeter',
        date: this.perimeterDateRange
      };
      questionQuery.getNewsListV2(params).then(
        res => {
          if (res.result.length) {
            this.latestPerimeterDateNum = res.result[0].dateNum;
            if (this.perimeterNewsDoc.scrollTop >= 0 && this.perimeterNewsDoc.scrollTop <= 300) {
              this.showPerimeterUnread = false;
              this.perimeterNewsDoc.scrollTop = 0;
              this.perimeterResultData.unshift(...res.result);
            } else {
              this.showPerimeterUnread = true;
              this.latestPerimeterData = this.latestPerimeterData.concat(res.result);
            }
          }
        },
        () => {
          this.getLatestPerimeterNewsSetInterval(false);
        }
      );
    },
    onShowPerimeterNewMessage() {
      this.showPerimeterUnread = false;
      this.perimeterResultData.unshift(...this.latestCompanyNewsData);
      this.latestPerimeterData = [];
      this.topPerimeterNewsTimer = setInterval(() => {
        if (this.perimeterNewsDoc.scrollTop) {
          this.perimeterNewsDoc.scrollTop = this.perimeterNewsDoc.scrollTop - 200;
        } else if (!this.perimeterNewsDoc.scrollTop || this.perimeterNewsDoc.scrollTop < 0) {
          clearInterval(this.topPerimeterNewsTimer);
        }
      }, 50);
    },
    getNewsListV2() {
      const params = {
        companies: [this.searchText],
        pageSize: this.pageSize,
        market: '全部',
        positive: this.positive,
        negative: this.negative,
        sourceGenre: this.source === '公众号' ? '微信' : this.source,
        earliestNewsId: this.earliestNewsId,
        earliestDateNum: this.earliestDateNum,
        latestDateNum: -1,
        company_importance_level: this.inewsImportanceLeverData.toString(),
        date: this.dateRange
      };
      this.isLoading = true;
      questionQuery.getNewsListV2(params).then(res => {
        this.isLoading = false;
        this.itemData = res.result;
        this.totalCount = res.totalCount;
        if (this.searchText === '浙江光大普特通讯科技股份有限公司') {
          this.itemData = this.itemData.filter(item => {
            return item.source === '挖贝网';
          });
          this.totalCount = 2;
        }
        this.busy = false;
        if (this.itemData.length) {
          this.earliestNewsId = this.itemData[this.itemData.length - 1].newsId;
          this.earliestDateNum = this.itemData[this.itemData.length - 1].dateNum;
          this.resultData = this.resultData.concat(this.itemData);
          this.busy = false;
        } else {
          this.busy = true;
        }
      });
    },
    getFirstNewsListV2() {
      const params = {
        companies: [this.searchText],
        pageSize: this.pageSize,
        market: '全部',
        positive: this.positive,
        negative: this.negative,
        sourceGenre: this.source === '公众号' ? '微信' : this.source,
        earliestNewsId: this.earliestNewsId,
        earliestDateNum: this.earliestDateNum,
        latestDateNum: -1,
        company_importance_level: this.inewsImportanceLeverData.toString(),
        date: this.dateRange
      };
      this.isLoading = true;
      questionQuery.getNewsListV2(params).then(res => {
        this.isLoading = false;
        this.itemData = res.result;
        this.totalCount = res.totalCount;
        if (this.searchText === '浙江光大普特通讯科技股份有限公司') {
          this.itemData = this.itemData.filter(item => {
            return item.source === '挖贝网';
          });
          this.totalCount = 2;
        }
        this.latestDateNum = res.result[0].dateNum;
        if (this.itemData.length) {
          this.earliestNewsId = this.itemData[this.itemData.length - 1].newsId;
          this.earliestDateNum = this.itemData[this.itemData.length - 1].dateNum;
          this.resultData = this.resultData.concat(this.itemData);
          this.busy = false;
        } else {
          this.busy = true;
        }
        this.getLatestNewsSetInterval(true);
      });
    },
    getLatestNewsSetInterval(start) {
      if (this.latestNewsTimer) {
        clearTimeout(this.latestNewsTimer);
      }
      if (start) {
        this.latestNewsTimer = setTimeout(() => {
          this.getLatestNewsListV2();
          this.getLatestNewsSetInterval(start);
        }, 1000 * 60);
      }
    },
    getCompanyPerimeterEventList() {
      this.isLoading = true;
      questionQuery.getCompanyPerimeterEvent(this.searchText, this.perimeterEventPageNum, this.perimeterEventPageSize, this.perimeterEventId).then(res => {
        this.isLoading = false;
        this.companyPerimeterEventItemData = res;
        if (this.companyPerimeterEventItemData.length) {
          const lastEvents = this.companyPerimeterEventItemData[this.companyPerimeterEventItemData.length - 1].events;
          this.perimeterEventId = lastEvents[lastEvents.length - 1].id;
          this.companyPerimeterEventItemData.forEach(item => {
            for (let i = 0; i < item.events.length - 1; i++) {
              for (let j = i + 1; j < item.events.length; j++) {
                if (item.events[i].title === item.events[j].title) {
                  item.events.splice(j, 1);
                  j--;
                }
              }
            }
            if (this.companyPerimeterEventData.length) {
              for (let m = 0; m < this.companyPerimeterEventData.length - 1; m++) {
                for (let n = 0; n < item.events.length - 1; n++) {
                  if (this.companyPerimeterEventData[m].title === item.events[n].title) {
                    item.events.splice(n, 1);
                    n--;
                  }
                }
              }
            }
          });
          if (this.companyPerimeterEventData.length) {
            const newCompanyPerimeterEventItemData = JSON.parse(JSON.stringify(this.companyPerimeterEventItemData));
            if (this.companyPerimeterEventData[this.companyPerimeterEventData.length - 1].month === this.companyPerimeterEventItemData[0].month) {
              this.companyPerimeterEventData[this.companyPerimeterEventData.length - 1].events = this.companyPerimeterEventData[this.companyPerimeterEventData.length - 1].events.concat(
                newCompanyPerimeterEventItemData.shift().events
              );
              this.companyPerimeterEventData = this.companyPerimeterEventData.concat(newCompanyPerimeterEventItemData);
            } else {
              this.companyPerimeterEventData = this.companyPerimeterEventData.concat(newCompanyPerimeterEventItemData);
            }
          } else {
            this.companyPerimeterEventData = this.companyPerimeterEventData.concat(this.companyPerimeterEventItemData);
          }
          this.companyPerimeterEventBusy = false;
        } else {
          this.companyPerimeterEventBusy = true;
        }
      });
    },
    loadMoreCompanyPerimeterEvent() {
      this.companyPerimeterEventBusy = true;
      if (this.companyPerimeterEventTimer) {
        clearTimeout(this.companyPerimeterEventTimer);
      }
      if (this.companyPerimeterEventItemData.length) {
        this.companyPerimeterEventTimer = setTimeout(() => {
          this.perimeterEventPageNum++;
          this.getCompanyPerimeterEventList();
        }, 500);
      }
    },
    getCompanyEventList() {
      this.isLoading = true;
      questionQuery.getCompanyEventList(this.searchText, this.eventPageNum, this.eventPageSize, this.eventId).then(res => {
        this.isLoading = false;
        this.companyEventItemData = res;
        if (this.companyEventItemData.length) {
          const lastEvents = this.companyEventItemData[this.companyEventItemData.length - 1].events;
          this.eventId = lastEvents[lastEvents.length - 1].id;
          this.companyEventItemData.forEach(item => {
            for (let i = 0; i < item.events.length - 1; i++) {
              for (let j = i + 1; j < item.events.length; j++) {
                if (item.events[i].title === item.events[j].title) {
                  item.events.splice(j, 1);
                  j--;
                }
              }
            }
            if (this.companyEventData.length) {
              for (let m = 0; m < this.companyEventData.length - 1; m++) {
                for (let n = 0; n < item.events.length - 1; n++) {
                  if (this.companyEventData[m].title === item.events[n].title) {
                    item.events.splice(n, 1);
                    n--;
                  }
                }
              }
            }
          });
          if (this.searchText === '浙江光大普特通讯科技股份有限公司') {
            this.companyEventItemData = this.companyEventItemData.filter(item => {
              return item.month === '2020年6月';
            });
          }
          if (this.companyEventData.length) {
            const newCompanyEventItemData = JSON.parse(JSON.stringify(this.companyEventItemData));
            if (this.companyEventData[this.companyEventData.length - 1].month === this.companyEventItemData[0].month) {
              this.companyEventData[this.companyEventData.length - 1].events = this.companyEventData[this.companyEventData.length - 1].events.concat(newCompanyEventItemData.shift().events);
              this.companyEventData = this.companyEventData.concat(newCompanyEventItemData);
            } else {
              this.companyEventData = this.companyEventData.concat(newCompanyEventItemData);
            }
          } else {
            this.companyEventData = this.companyEventData.concat(this.companyEventItemData);
          }
          this.companyEventBusy = false;
        } else {
          this.companyEventBusy = true;
        }
      });
    },
    loadMoreCompanyEvent() {
      this.companyEventBusy = true;
      if (this.companyEventTimer) {
        clearTimeout(this.companyEventTimer);
      }
      if (this.companyEventItemData.length) {
        this.companyEventTimer = setTimeout(() => {
          this.eventPageNum++;
          this.getCompanyEventList();
        }, 500);
      }
    },
    payAttentionToCompany() {
      questionQuery.payAttentionToCompany(this.username, this.searchText).then(res => {
        this.existed = res.existed;
      });
    }
  },
  watch: {
    showTodayCompanyDialog(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    },
    searchText() {
      this.$nextTick(() => document.querySelector('.content-header').scrollIntoView({ block: 'center' }));
    },
    async $route(to) {
      this.getLatestNewsSetInterval(false);
      this.getLatestPerimeterNewsSetInterval(false);
      this.searchText = to.query.q || '';
      this.getStockCode();
      this.payAttentionToCompany();
      if (!this.$route.query.original) {
        const companyParams = {
          companies: [this.searchText],
          pageSize: 1,
          market: '全部',
          positive: [],
          negative: [],
          sourceGenre: '全部来源',
          earliestNewsId: -1,
          earliestDateNum: -1,
          latestDateNum: -1
        };
        const companyParamsRes = await questionQuery.getNewsListV2(companyParams);
        this.hasNews = !!companyParamsRes.totalCount;
        const companyPerimeterParams = {
          companies: [this.searchText],
          pageSize: 1,
          market: '全部',
          positive: [],
          negative: [],
          sourceGenre: '全部来源',
          earliestNewsId: -1,
          earliestDateNum: -1,
          latestDateNum: -1,
          type: 'perimeter'
        };
        const companyPerimeterParamsRes = await questionQuery.getNewsListV2(companyPerimeterParams);
        this.hasPerimeterNews = !!companyPerimeterParamsRes.totalCount;
        const companyEventRes = await questionQuery.getCompanyEventList(this.searchText, 1, 1, -1);
        this.hasCompanyEvent = !!companyEventRes.length;
        const companyPerimeterEventRes = await questionQuery.getCompanyPerimeterEvent(this.searchText, 1, 1, -1);
        this.hasCompanyPerimeterEvent = !!companyPerimeterEventRes.length;
      }
      if (this.$route.query.type) {
        if (this.hasCompanyEvent && this.hasCompanyPerimeterEvent && this.hasNews && this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻', '事件'];
          this.perimeterNewsTabs = ['新闻', '事件'];
          this.selectedOptionTab = '周边舆情';
          this.selectedCompanyTab = '新闻';
          this.selectedPerimeterTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.perimeterSource = '全部来源';
          this.perimeterPageNum = 1;
          this.earliestPerimeterNewsId = -1;
          this.earliestPerimeterDateNum = -1;
          this.latestPerimeterDateNum = -1;
          this.perimeterItemData = [];
          this.perimeterResultData = [];
          this.tagType = 'related-company';
          this.getNewsListTag();
          this.getFirstPerimeterNewsListV2();
        } else if (this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['事件'];
          this.perimeterNewsTabs = ['事件'];
          this.selectedOptionTab = '周边舆情';
          this.selectedCompanyTab = '事件';
          this.selectedPerimeterTab = '事件';
          this.companyPerimeterEventData = [];
          this.companyPerimeterEventItemData = [];
          this.perimeterEventPageNum = 1;
          this.perimeterEventId = -1;
          this.getCompanyPerimeterEventList();
        } else if (this.hasCompanyEvent && !this.hasNews && !this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['事件'];
          this.perimeterNewsTabs = ['新闻'];
          this.selectedOptionTab = '周边舆情';
          this.selectedCompanyTab = '事件';
          this.selectedPerimeterTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.perimeterSource = '全部来源';
          this.perimeterPageNum = 1;
          this.earliestPerimeterNewsId = -1;
          this.earliestPerimeterDateNum = -1;
          this.latestPerimeterDateNum = -1;
          this.perimeterItemData = [];
          this.perimeterResultData = [];
          this.tagType = 'related-company';
          this.getNewsListTag();
          this.getFirstPerimeterNewsListV2();
        } else if (!this.hasCompanyEvent && this.hasNews && this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻'];
          this.perimeterNewsTabs = ['事件'];
          this.selectedOptionTab = '周边舆情';
          this.selectedCompanyTab = '新闻';
          this.selectedPerimeterTab = '事件';
          this.companyPerimeterEventData = [];
          this.companyPerimeterEventItemData = [];
          this.perimeterEventPageNum = 1;
          this.perimeterEventId = -1;
          this.getCompanyPerimeterEventList();
        } else if (!this.hasCompanyEvent && this.hasNews && !this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻'];
          this.perimeterNewsTabs = ['新闻'];
          this.selectedOptionTab = '周边舆情';
          this.selectedCompanyTab = '新闻';
          this.selectedPerimeterTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.perimeterSource = '全部来源';
          this.perimeterPageNum = 1;
          this.earliestPerimeterNewsId = -1;
          this.earliestPerimeterDateNum = -1;
          this.latestPerimeterDateNum = -1;
          this.perimeterItemData = [];
          this.perimeterResultData = [];
          this.tagType = 'related-company';
          this.getNewsListTag();
          this.getFirstPerimeterNewsListV2();
        } else if (this.hasCompanyEvent && this.hasNews && this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻', '事件'];
          this.perimeterNewsTabs = ['事件'];
          this.selectedOptionTab = '周边舆情';
          this.selectedCompanyTab = '新闻';
          this.selectedPerimeterTab = '事件';
          this.companyPerimeterEventData = [];
          this.companyPerimeterEventItemData = [];
          this.perimeterEventPageNum = 1;
          this.perimeterEventId = -1;
          this.getCompanyPerimeterEventList();
        } else if (this.hasCompanyEvent && this.hasNews && !this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻', '事件'];
          this.perimeterNewsTabs = ['新闻'];
          this.selectedOptionTab = '周边舆情';
          this.selectedCompanyTab = '新闻';
          this.selectedPerimeterTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.perimeterSource = '全部来源';
          this.perimeterPageNum = 1;
          this.earliestPerimeterNewsId = -1;
          this.earliestPerimeterDateNum = -1;
          this.latestPerimeterDateNum = -1;
          this.perimeterItemData = [];
          this.perimeterResultData = [];
          this.tagType = 'related-company';
          this.getNewsListTag();
          this.getFirstPerimeterNewsListV2();
        } else if (this.hasCompanyEvent && this.hasNews && !this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
          this.$router.push({
            path: res.path,
            query: {
              q: this.$route.query.q
            }
          });
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻', '事件'];
          this.perimeterNewsTabs = [];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '新闻';
          this.companyEventData = [];
          this.companyEventItemData = [];
          this.eventPageNum = 1;
          this.eventId = -1;
          this.getCompanyEventList();
        } else if (this.hasCompanyEvent && !this.hasNews && !this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
          this.$router.push({
            path: res.path,
            query: {
              q: this.$route.query.q
            }
          });
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['事件'];
          this.perimeterNewsTabs = [];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '事件';
          this.companyEventData = [];
          this.companyEventItemData = [];
          this.eventPageNum = 1;
          this.eventId = -1;
          this.getCompanyEventList();
        } else if (!this.hasCompanyEvent && this.hasNews && !this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
          this.$router.push({
            path: res.path,
            query: {
              q: this.$route.query.q
            }
          });
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻'];
          this.perimeterNewsTabs = [];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.itemData = [];
          this.resultData = [];
          this.source = '全部来源';
          this.pageNum = 1;
          this.earliestNewsId = -1;
          this.earliestDateNum = -1;
          this.latestDateNum = -1;
          this.tagType = 'company';
          this.getNewsListTag();
          this.getFirstNewsListV2();
        } else if (!this.hasCompanyEvent && !this.hasNews && !this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
          this.headerTabs = [];
          this.dateRangeTabs = [];
          this.perimeterNewsTabs = [];
        } else if (this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['事件'];
          this.perimeterNewsTabs = ['新闻', '事件'];
          this.selectedOptionTab = '周边舆情';
          this.selectedCompanyTab = '事件';
          this.selectedPerimeterTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.perimeterSource = '全部来源';
          this.perimeterPageNum = 1;
          this.earliestPerimeterNewsId = -1;
          this.earliestPerimeterDateNum = -1;
          this.latestPerimeterDateNum = -1;
          this.perimeterItemData = [];
          this.perimeterResultData = [];
          this.tagType = 'related-company';
          this.getNewsListTag();
          this.getFirstPerimeterNewsListV2();
        } else if (!this.hasCompanyEvent && this.hasNews && this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻'];
          this.perimeterNewsTabs = ['新闻', '事件'];
          this.selectedOptionTab = '周边舆情';
          this.selectedCompanyTab = '新闻';
          this.selectedPerimeterTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.perimeterSource = '全部来源';
          this.perimeterPageNum = 1;
          this.earliestPerimeterNewsId = -1;
          this.earliestPerimeterDateNum = -1;
          this.latestPerimeterDateNum = -1;
          this.perimeterItemData = [];
          this.perimeterResultData = [];
          this.tagType = 'related-company';
          this.getNewsListTag();
          this.getFirstPerimeterNewsListV2();
        } else if (!this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.perimeterNewsTabs = ['新闻', '事件'];
          this.selectedOptionTab = '周边舆情';
          this.selectedPerimeterTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.perimeterSource = '全部来源';
          this.perimeterPageNum = 1;
          this.earliestPerimeterNewsId = -1;
          this.earliestPerimeterDateNum = -1;
          this.latestPerimeterDateNum = -1;
          this.perimeterItemData = [];
          this.perimeterResultData = [];
          this.tagType = 'related-company';
          this.getNewsListTag();
          this.getFirstPerimeterNewsListV2();
        } else if (!this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.perimeterNewsTabs = ['事件'];
          this.selectedOptionTab = '周边舆情';
          this.selectedPerimeterTab = '事件';
          this.companyPerimeterEventData = [];
          this.companyPerimeterEventItemData = [];
          this.perimeterEventPageNum = 1;
          this.perimeterEventId = -1;
          this.getCompanyPerimeterEventList();
        } else if (!this.hasCompanyEvent && !this.hasNews && !this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.perimeterNewsTabs = ['新闻'];
          this.selectedOptionTab = '周边舆情';
          this.selectedPerimeterTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.perimeterSource = '全部来源';
          this.perimeterPageNum = 1;
          this.earliestPerimeterNewsId = -1;
          this.earliestPerimeterDateNum = -1;
          this.latestPerimeterDateNum = -1;
          this.perimeterItemData = [];
          this.perimeterResultData = [];
          this.tagType = 'related-company';
          this.getNewsListTag();
          this.getFirstPerimeterNewsListV2();
        }
      } else if (!this.$route.query.type) {
        if (!this.hasCompanyEvent && !this.hasCompanyPerimeterEvent && !this.hasNews && !this.hasPerimeterNews) {
          this.headerTabs = [];
          this.dateRangeTabs = [];
          this.perimeterNewsTabs = [];
          this.selectedOptionTab = '';
          this.selectedCompanyTab = '';
          this.selectedPerimeterTab = '';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.itemData = [];
          this.resultData = [];
          this.companyEventData = [];
          this.companyEventItemData = [];
          this.perimeterItemData = [];
          this.perimeterResultData = [];
          this.companyPerimeterEventData = [];
          this.companyPerimeterEventItemData = [];
        } else if (!this.hasCompanyPerimeterEvent && !this.hasPerimeterNews && !this.hasCompanyEvent && this.hasNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻'];
          this.perimeterNewsTabs = [];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.itemData = [];
          this.resultData = [];
          this.source = '全部来源';
          this.pageNum = 1;
          this.earliestNewsId = -1;
          this.earliestDateNum = -1;
          this.latestDateNum = -1;
          this.tagType = 'company';
          this.getNewsListTag();
          this.getFirstNewsListV2();
        } else if (!this.hasCompanyPerimeterEvent && !this.hasPerimeterNews && this.hasCompanyEvent && !this.hasNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['事件'];
          this.perimeterNewsTabs = [];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '事件';
          this.companyEventData = [];
          this.companyEventItemData = [];
          this.eventPageNum = 1;
          this.eventId = -1;
          this.getCompanyEventList();
        } else if (this.hasCompanyPerimeterEvent && !this.hasPerimeterNews && this.hasCompanyEvent && this.hasNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻', '事件'];
          this.perimeterNewsTabs = ['事件'];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '新闻';
          this.selectedPerimeterTab = '事件';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.itemData = [];
          this.resultData = [];
          this.source = '全部来源';
          this.pageNum = 1;
          this.earliestNewsId = -1;
          this.earliestDateNum = -1;
          this.latestDateNum = -1;
          this.tagType = 'company';
          this.getNewsListTag();
          this.getFirstNewsListV2();
        } else if (!this.hasCompanyPerimeterEvent && this.hasPerimeterNews && this.hasCompanyEvent && this.hasNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻', '事件'];
          this.perimeterNewsTabs = ['新闻'];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '新闻';
          this.selectedPerimeterTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.itemData = [];
          this.resultData = [];
          this.source = '全部来源';
          this.pageNum = 1;
          this.earliestNewsId = -1;
          this.earliestDateNum = -1;
          this.latestDateNum = -1;
          this.tagType = 'company';
          this.getNewsListTag();
          this.getFirstNewsListV2();
        } else if (!this.hasCompanyPerimeterEvent && this.hasPerimeterNews && !this.hasCompanyEvent && this.hasNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻'];
          this.perimeterNewsTabs = ['新闻'];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '新闻';
          this.selectedPerimeterTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.itemData = [];
          this.resultData = [];
          this.source = '全部来源';
          this.pageNum = 1;
          this.earliestNewsId = -1;
          this.earliestDateNum = -1;
          this.latestDateNum = -1;
          this.tagType = 'company';
          this.getNewsListTag();
          this.getFirstNewsListV2();
        } else if (!this.hasCompanyPerimeterEvent && !this.hasPerimeterNews && this.hasCompanyEvent && this.hasNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻', '事件'];
          this.perimeterNewsTabs = [];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.itemData = [];
          this.resultData = [];
          this.source = '全部来源';
          this.pageNum = 1;
          this.earliestNewsId = -1;
          this.earliestDateNum = -1;
          this.latestDateNum = -1;
          this.tagType = 'company';
          this.getNewsListTag();
          this.getFirstNewsListV2();
        } else if (this.hasCompanyPerimeterEvent && this.hasPerimeterNews && !this.hasCompanyEvent && this.hasNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻'];
          this.perimeterNewsTabs = ['新闻', '事件'];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '新闻';
          this.selectedPerimeterTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.itemData = [];
          this.resultData = [];
          this.source = '全部来源';
          this.pageNum = 1;
          this.earliestNewsId = -1;
          this.earliestDateNum = -1;
          this.latestDateNum = -1;
          this.tagType = 'company';
          this.getNewsListTag();
          this.getFirstNewsListV2();
        } else if (!this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.perimeterNewsTabs = ['新闻', '事件'];
          this.selectedOptionTab = '周边舆情';
          this.selectedPerimeterTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.perimeterSource = '全部来源';
          this.perimeterPageNum = 1;
          this.earliestPerimeterNewsId = -1;
          this.earliestPerimeterDateNum = -1;
          this.latestPerimeterDateNum = -1;
          this.perimeterItemData = [];
          this.perimeterResultData = [];
          this.tagType = 'related-company';
          this.getNewsListTag();
          this.getFirstPerimeterNewsListV2();
        } else if (!this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.perimeterNewsTabs = ['事件'];
          this.selectedOptionTab = '周边舆情';
          this.selectedPerimeterTab = '事件';
          this.companyPerimeterEventData = [];
          this.companyPerimeterEventItemData = [];
          this.perimeterEventPageNum = 1;
          this.perimeterEventId = -1;
          this.getCompanyPerimeterEventList();
        } else if (!this.hasCompanyEvent && !this.hasNews && !this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.perimeterNewsTabs = ['新闻'];
          this.selectedOptionTab = '周边舆情';
          this.selectedPerimeterTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.perimeterSource = '全部来源';
          this.perimeterPageNum = 1;
          this.earliestPerimeterNewsId = -1;
          this.earliestPerimeterDateNum = -1;
          this.latestPerimeterDateNum = -1;
          this.perimeterItemData = [];
          this.perimeterResultData = [];
          this.tagType = 'related-company';
          this.getNewsListTag();
          this.getFirstPerimeterNewsListV2();
        } else if (this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['事件'];
          this.perimeterNewsTabs = ['新闻', '事件'];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '事件';
          this.selectedPerimeterTab = '事件';
          this.companyEventData = [];
          this.companyEventItemData = [];
          this.eventPageNum = 1;
          this.eventId = -1;
          this.getCompanyEventList();
        } else if (this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['事件'];
          this.perimeterNewsTabs = ['事件'];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '事件';
          this.selectedPerimeterTab = '事件';
          this.companyEventData = [];
          this.companyEventItemData = [];
          this.eventPageNum = 1;
          this.eventId = -1;
          this.getCompanyEventList();
        } else if (this.hasCompanyEvent && !this.hasNews && !this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['事件'];
          this.perimeterNewsTabs = ['新闻'];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '事件';
          this.selectedPerimeterTab = '新闻';
          this.companyEventData = [];
          this.companyEventItemData = [];
          this.eventPageNum = 1;
          this.eventId = -1;
          this.getCompanyEventList();
        } else if (!this.hasCompanyEvent && this.hasNews && this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻'];
          this.perimeterNewsTabs = ['事件'];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '新闻';
          this.selectedPerimeterTab = '事件';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.itemData = [];
          this.resultData = [];
          this.source = '全部来源';
          this.pageNum = 1;
          this.earliestNewsId = -1;
          this.earliestDateNum = -1;
          this.latestDateNum = -1;
          this.tagType = 'company';
          this.getNewsListTag();
          this.getFirstNewsListV2();
        } else if (this.hasCompanyPerimeterEvent && this.hasPerimeterNews && this.hasCompanyEvent && this.hasNews) {
          this.headerTabs = [
            {
              name: '公司舆情',
              path: '/result'
            },
            {
              name: '周边舆情',
              path: '/result'
            }
          ];
          this.dateRangeTabs = ['新闻', '事件'];
          this.perimeterNewsTabs = ['新闻', '事件'];
          this.selectedOptionTab = '公司舆情';
          this.selectedCompanyTab = '新闻';
          this.selectedPerimeterTab = '新闻';
          this.filterTag = null;
          this.negative = [];
          this.positive = [];
          this.itemData = [];
          this.resultData = [];
          this.source = '全部来源';
          this.pageNum = 1;
          this.earliestNewsId = -1;
          this.earliestDateNum = -1;
          this.latestDateNum = -1;
          this.tagType = 'company';
          this.getNewsListTag();
          this.getFirstNewsListV2();
        }
      }
      if (to.query.valueTag) {
        this.valueTag = [to.query.valueTag] || [];
      }
    }
  },
  created() {
    this.searchText = this.$route.query.q || '';
    if (this.$route.query.valueTag) {
      this.valueTag = [this.$route.query.valueTag] || [];
    }
    this.$nextTick(() => document.querySelector('.content-header').scrollIntoView({ block: 'center' }));
  },
  async mounted() {
    eventBus.$emit('toOtherPage');
    const companyParams = {
      companies: [this.searchText],
      pageSize: 1,
      market: '全部',
      positive: this.positive,
      negative: this.negative,
      sourceGenre: this.source === '公众号' ? '微信' : this.source,
      earliestNewsId: this.earliestNewsId,
      earliestDateNum: this.earliestDateNum,
      latestDateNum: -1
    };
    const companyParamsRes = await questionQuery.getNewsListV2(companyParams);
    this.hasNews = !!companyParamsRes.totalCount;
    if (this.hasNews && !this.$route.query.type) {
      this.selectedOptionTab = '公司舆情';
      this.selectedCompanyTab = '新闻';
      this.tagType = 'company';
      this.getNewsListTag();
      this.getFirstNewsListV2();
    }
    const companyPerimeterParams = {
      companies: [this.searchText],
      pageSize: 1,
      market: '全部',
      positive: this.positive,
      negative: this.negative,
      sourceGenre: this.perimeterSource === '公众号' ? '微信' : this.perimeterSource,
      earliestNewsId: this.earliestPerimeterNewsId,
      earliestDateNum: this.earliestPerimeterDateNum,
      latestDateNum: -1,
      type: 'perimeter'
    };
    const companyPerimeterParamsRes = await questionQuery.getNewsListV2(companyPerimeterParams);
    this.hasPerimeterNews = !!companyPerimeterParamsRes.totalCount;
    const companyEventRes = await questionQuery.getCompanyEventList(this.searchText, 1, 1, -1);
    this.hasCompanyEvent = !!companyEventRes.length;
    const companyPerimeterEventRes = await questionQuery.getCompanyPerimeterEvent(this.searchText, 1, 1, -1);
    this.hasCompanyPerimeterEvent = !!companyPerimeterEventRes.length;
    if (this.$route.query.type) {
      if (this.hasCompanyEvent && this.hasCompanyPerimeterEvent && this.hasNews && this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻', '事件'];
        this.perimeterNewsTabs = ['新闻', '事件'];
        this.selectedOptionTab = '周边舆情';
        this.selectedCompanyTab = '新闻';
        this.selectedPerimeterTab = '新闻';
        this.tagType = 'related-company';
        this.getNewsListTag();
        this.getFirstPerimeterNewsListV2();
      } else if (this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['事件'];
        this.perimeterNewsTabs = ['事件'];
        this.selectedOptionTab = '周边舆情';
        this.selectedCompanyTab = '事件';
        this.selectedPerimeterTab = '事件';
        this.getCompanyPerimeterEventList();
      } else if (this.hasCompanyEvent && !this.hasNews && !this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['事件'];
        this.perimeterNewsTabs = ['新闻'];
        this.selectedOptionTab = '周边舆情';
        this.selectedCompanyTab = '事件';
        this.selectedPerimeterTab = '新闻';
        this.tagType = 'related-company';
        this.getNewsListTag();
        this.getFirstPerimeterNewsListV2();
      } else if (!this.hasCompanyEvent && this.hasNews && this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻'];
        this.perimeterNewsTabs = ['事件'];
        this.selectedOptionTab = '周边舆情';
        this.selectedCompanyTab = '新闻';
        this.selectedPerimeterTab = '事件';
        this.getCompanyPerimeterEventList();
      } else if (!this.hasCompanyEvent && this.hasNews && !this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻'];
        this.perimeterNewsTabs = ['新闻'];
        this.selectedOptionTab = '周边舆情';
        this.selectedCompanyTab = '新闻';
        this.selectedPerimeterTab = '新闻';
        this.tagType = 'related-company';
        this.getNewsListTag();
        this.getFirstPerimeterNewsListV2();
      } else if (this.hasCompanyEvent && this.hasNews && this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻', '事件'];
        this.perimeterNewsTabs = ['事件'];
        this.selectedOptionTab = '周边舆情';
        this.selectedCompanyTab = '新闻';
        this.selectedPerimeterTab = '事件';
        this.getCompanyPerimeterEventList();
      } else if (this.hasCompanyEvent && this.hasNews && !this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻', '事件'];
        this.perimeterNewsTabs = ['新闻'];
        this.selectedOptionTab = '周边舆情';
        this.selectedCompanyTab = '新闻';
        this.selectedPerimeterTab = '新闻';
        this.tagType = 'related-company';
        this.getNewsListTag();
        this.getFirstPerimeterNewsListV2();
      } else if (this.hasCompanyEvent && this.hasNews && !this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
        this.$router.push({
          path: res.path,
          query: {
            q: this.$route.query.q
          }
        });
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻', '事件'];
        this.perimeterNewsTabs = [];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '新闻';
        this.tagType = 'company';
        this.getNewsListTag();
        this.getFirstNewsListV2();
      } else if (this.hasCompanyEvent && !this.hasNews && !this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
        this.$router.push({
          path: res.path,
          query: {
            q: this.$route.query.q
          }
        });
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['事件'];
        this.perimeterNewsTabs = [];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '事件';
        this.getCompanyEventList();
      } else if (!this.hasCompanyEvent && this.hasNews && !this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
        this.$router.push({
          path: res.path,
          query: {
            q: this.$route.query.q
          }
        });
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻'];
        this.perimeterNewsTabs = [];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '新闻';
        this.tagType = 'company';
        this.getNewsListTag();
        this.getFirstNewsListV2();
      } else if (!this.hasCompanyEvent && !this.hasNews && !this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
        this.headerTabs = [];
        this.dateRangeTabs = [];
        this.perimeterNewsTabs = [];
      } else if (this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['事件'];
        this.perimeterNewsTabs = ['新闻', '事件'];
        this.selectedOptionTab = '周边舆情';
        this.selectedCompanyTab = '事件';
        this.selectedPerimeterTab = '新闻';
        this.tagType = 'related-company';
        this.getNewsListTag();
        this.getFirstPerimeterNewsListV2();
      } else if (!this.hasCompanyEvent && this.hasNews && this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻'];
        this.perimeterNewsTabs = ['新闻', '事件'];
        this.selectedOptionTab = '周边舆情';
        this.selectedCompanyTab = '新闻';
        this.selectedPerimeterTab = '新闻';
        this.tagType = 'related-company';
        this.getNewsListTag();
        this.getFirstPerimeterNewsListV2();
      } else if (!this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.perimeterNewsTabs = ['新闻', '事件'];
        this.selectedOptionTab = '周边舆情';
        this.selectedPerimeterTab = '新闻';
        this.tagType = 'related-company';
        this.getNewsListTag();
        this.getFirstPerimeterNewsListV2();
      } else if (!this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.perimeterNewsTabs = ['事件'];
        this.selectedOptionTab = '周边舆情';
        this.selectedPerimeterTab = '事件';
        this.getCompanyPerimeterEventList();
      } else if (!this.hasCompanyEvent && !this.hasNews && !this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.perimeterNewsTabs = ['新闻'];
        this.selectedOptionTab = '周边舆情';
        this.selectedPerimeterTab = '新闻';
        this.tagType = 'related-company';
        this.getNewsListTag();
        this.getFirstPerimeterNewsListV2();
      }
    } else if (!this.$route.query.type) {
      if (!this.hasCompanyEvent && !this.hasCompanyPerimeterEvent && !this.hasNews && !this.hasPerimeterNews) {
        this.headerTabs = [];
        this.dateRangeTabs = [];
        this.perimeterNewsTabs = [];
        this.selectedOptionTab = '';
        this.selectedCompanyTab = '';
        this.selectedPerimeterTab = '';
        this.filterTag = null;
        this.negative = [];
        this.positive = [];
        this.itemData = [];
        this.resultData = [];
        this.companyEventData = [];
        this.companyEventItemData = [];
        this.perimeterItemData = [];
        this.perimeterResultData = [];
        this.companyPerimeterEventData = [];
        this.companyPerimeterEventItemData = [];
      } else if (!this.hasCompanyPerimeterEvent && !this.hasPerimeterNews && !this.hasCompanyEvent && this.hasNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻'];
        this.perimeterNewsTabs = [];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '新闻';
        this.tagType = 'company';
      } else if (!this.hasCompanyPerimeterEvent && !this.hasPerimeterNews && this.hasCompanyEvent && !this.hasNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['事件'];
        this.perimeterNewsTabs = [];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '事件';
        this.getCompanyEventList();
      } else if (this.hasCompanyPerimeterEvent && !this.hasPerimeterNews && this.hasCompanyEvent && this.hasNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻', '事件'];
        this.perimeterNewsTabs = ['事件'];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '新闻';
        this.selectedPerimeterTab = '事件';
        this.tagType = 'company';
      } else if (!this.hasCompanyPerimeterEvent && this.hasPerimeterNews && this.hasCompanyEvent && this.hasNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻', '事件'];
        this.perimeterNewsTabs = ['新闻'];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '新闻';
        this.selectedPerimeterTab = '新闻';
        this.tagType = 'company';
      } else if (!this.hasCompanyPerimeterEvent && this.hasPerimeterNews && !this.hasCompanyEvent && this.hasNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻'];
        this.perimeterNewsTabs = ['新闻'];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '新闻';
        this.selectedPerimeterTab = '新闻';
        this.tagType = 'company';
      } else if (!this.hasCompanyPerimeterEvent && !this.hasPerimeterNews && this.hasCompanyEvent && this.hasNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻', '事件'];
        this.perimeterNewsTabs = [];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '新闻';
        this.tagType = 'company';
      } else if (this.hasCompanyPerimeterEvent && this.hasPerimeterNews && !this.hasCompanyEvent && this.hasNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻'];
        this.perimeterNewsTabs = ['新闻', '事件'];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '新闻';
        this.selectedPerimeterTab = '新闻';
        this.tagType = 'company';
      } else if (!this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.perimeterNewsTabs = ['新闻', '事件'];
        this.selectedOptionTab = '周边舆情';
        this.selectedPerimeterTab = '新闻';
        this.tagType = 'related-company';
        this.getNewsListTag();
        this.getFirstPerimeterNewsListV2();
      } else if (!this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.perimeterNewsTabs = ['事件'];
        this.selectedOptionTab = '周边舆情';
        this.selectedPerimeterTab = '事件';
        this.getCompanyPerimeterEventList();
      } else if (!this.hasCompanyEvent && !this.hasNews && !this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.perimeterNewsTabs = ['新闻'];
        this.selectedOptionTab = '周边舆情';
        this.selectedPerimeterTab = '新闻';
        this.tagType = 'related-company';
        this.getNewsListTag();
        this.getFirstPerimeterNewsListV2();
      } else if (this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['事件'];
        this.perimeterNewsTabs = ['新闻', '事件'];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '事件';
        this.selectedPerimeterTab = '新闻';
        this.getCompanyEventList();
      } else if (this.hasCompanyEvent && !this.hasNews && this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['事件'];
        this.perimeterNewsTabs = ['事件'];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '事件';
        this.selectedPerimeterTab = '事件';
        this.getCompanyEventList();
      } else if (this.hasCompanyEvent && !this.hasNews && !this.hasCompanyPerimeterEvent && this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['事件'];
        this.perimeterNewsTabs = ['新闻'];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '事件';
        this.selectedPerimeterTab = '新闻';
        this.getCompanyEventList();
      } else if (!this.hasCompanyEvent && this.hasNews && this.hasCompanyPerimeterEvent && !this.hasPerimeterNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻'];
        this.perimeterNewsTabs = ['事件'];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '新闻';
        this.selectedPerimeterTab = '事件';
        this.tagType = 'company';
      } else if (this.hasCompanyPerimeterEvent && this.hasPerimeterNews && this.hasCompanyEvent && this.hasNews) {
        this.headerTabs = [
          {
            name: '公司舆情',
            path: '/result'
          },
          {
            name: '周边舆情',
            path: '/result'
          }
        ];
        this.dateRangeTabs = ['新闻', '事件'];
        this.perimeterNewsTabs = ['新闻', '事件'];
        this.selectedOptionTab = '公司舆情';
        this.selectedCompanyTab = '新闻';
        this.selectedPerimeterTab = '新闻';
        this.tagType = 'company';
      }
    }
    this.getStockCode();
    this.companyNewsDoc = document.querySelector('.company-result-news-list');
    this.perimeterNewsDoc = document.querySelector('.perimeter-result-news-list');
    this.username = authService.getLoggedUserName();
    this.resultRightContent = document.querySelector('.result-right-content');
    this.payAttentionToCompany();
  },
  destroyed() {
    this.getLatestPerimeterNewsSetInterval(false);
    this.getLatestNewsSetInterval(false);
    if (this.latestCompanyNewsTimer) {
      clearInterval(this.latestCompanyNewsTimer);
    }
  },
  components: {
    EntityNewsStatistics,
    PerimeterCompany,
    EntityAlarmStandAloneSetting,
    BackTop,
    SentimentTrends,
    CompanyEventList,
    CriteriaSearchArea,
    NewsListItem,
    SelectCategory,
    NewGroup,
    SnDatePicker,
    CompanyDateNewsDialog
  }
};
</script>

<style lang="scss" scoped>
.icon {
  width: 16px;
}
.loading {
  padding: 12px 0;
  margin: 0 auto;
  height: 10px;
  width: 772px;
  color: #666666;
  text-align: center;
}
.event-loading {
  padding: 12px 0;
  height: 10px;
  width: 772px;
  color: #666666;
  text-align: center;
}
.result-container {
  padding-bottom: 16px;
  min-height: 100%;

  .content-box {
    position: relative;
    margin: 16px auto;
    width: 1200px;
    .content-header {
      padding: 16px 20px 8px;
      align-items: center;
      font-size: 32px;
      font-weight: 600;
      font-stretch: normal;
      letter-spacing: 0px;
      color: rgba(23, 31, 70, 1);
      line-height: 45px;
      background-color: #ffffff;
      .attention-btn {
        width: 86px;
        height: 28px;
        background: rgba(69, 168, 204, 1);
        border-radius: 2px;
        line-height: 14px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        margin: 10px 24px;
        text-align: center;
        padding: 6px;
        cursor: pointer;
      }
      .add-attention-btn {
        padding-left: 12px;
      }
      .add-attention-btn::before {
        content: '';
        display: block;
        width: 16px;
        height: 16px;
        background-image: url('../assets/img/pay-attention.svg');
      }
      .delete-attention-btn {
        background: rgba(69, 168, 204, 0.59);
      }
      .edit-notification-icon-bg {
        width: 28px;
        height: 28px;
        margin-top: 3px;
        margin-left: 8px;
        padding: 4px;
        border: 2px solid transparent;
        border-radius: 4px;
        border-color: rgba(255, 255, 255, 0.2);
        &:hover {
          border-color: rgba(255, 255, 255, 0.4);
        }
        &:active {
          border-color: rgba(255, 255, 255, 0.2);
        }
      }
      .alarm-bg {
        padding: 6px;
        border: none;
        background-color: rgba(91, 90, 95, 0.3);
        &:hover {
          background-color: rgba(91, 90, 95, 0.5);
        }
        &:active {
          background-color: rgba(91, 90, 95, 0.3);
        }
      }
      .edit-notification-icon {
        width: 16px;
        height: 16px;
        background-image: url('../assets/img/small-bell.svg');
        background-size: cover;
      }
      .alarm {
        background-image: url('../assets/img/small-bell2.svg');
        background-size: cover;
      }
    }
    .company-name {
      padding-left: 20px;
      color: #464d6c;
      font-size: 14px;
      font-weight: 500;
      font-weight: 600;
      background: #ffffff;
    }
    .content-body {
      .section {
        position: relative;
        width: 1200px;
        margin: 10px auto 0 auto;
        .left {
          float: left;
          width: 814px;
          background-color: #ffffff;
          .header-tab {
            justify-content: space-between;
            padding: 0 24px;
            height: 44px;
            line-height: 44px;
            width: 100%;
            box-shadow: inset 0px -1px 0px 0px#f7f7fa;
            background-color: #ffffff;
            font-size: 14px;
            .tab-item {
              margin-right: 32px;
              color: #747990;
              cursor: pointer;
              &:hover {
                color: #171f46;
              }
            }
            .tab-item-active {
              position: relative;
              color: #171f46;
            }
            .tab-item-active::after {
              content: '';
              position: absolute;
              top: 35px;
              left: 50%;
              transform: translateX(-50%);
              width: 14px;
              height: 3px;
              background-color: #171f46;
            }
          }
          .news-type-tab {
            width: 100%;
            padding: 16px 24px;
            background-color: #ffffff;
            box-shadow: inset 0px -1px 0px 0px#f7f7fa;
            .news-type-tab-btn {
              height: 26px;
              width: 52px;
              margin-left: 0;
              margin-right: 10px;
              padding: 0;
              border-radius: 2px;
              border: none;
              font-size: 14px;
              color: #747990;
              background-color: #f7f8fc;
              font-weight: 400;
              &:hover {
                color: #747990;
                background-color: #eaebef;
              }
              &:focus {
                color: #747990;
                background-color: #eaebef;
              }
              &:active {
                color: #747990;
                background-color: #eaebef;
              }
            }
            .news-type-tab-active {
              color: #ffffff;
              background-color: #45a8cc;
              &:hover {
                color: #ffffff;
                background-color: #3e97b8;
              }
              &:focus {
                color: #ffffff;
                background-color: #3e97b8;
              }
              &:active {
                color: #ffffff;
                background-color: #3e97b8;
              }
            }
          }
          .company-event-list {
            padding-left: 27px;
            height: 680px;
            width: 100%;
            overflow: auto;
            background-color: #ffffff;
          }
          .company-news-list {
            padding: 16px 0;
            .company-news-list-header {
              padding: 0 24px;
            }
            .news-list-source-filter {
              position: relative;
              justify-content: space-between;
              width: 100%;
              height: 48px;
              line-height: 48px;
              border-bottom: 1px solid #f7f7fa;
              .company-news-unread-message {
                position: absolute;
                top: 52px;
                left: 50%;
                transform: translateX(-50%);
                padding: 0 12px;
                height: 17px;
                background-color: #636772;
                border-radius: 2px;
                z-index: 1;
                cursor: pointer;
                .company-news-unread-count {
                  margin-right: 4px;
                  margin-top: -15px;
                  color: #ffffff;
                  font-size: 12px;
                  cursor: pointer;
                }
              }
              .total-count {
                color: #747990;
                font-size: 12px;
              }
              .news-list-source-filter-right {
                .clues-show-btn {
                  margin-left: 10px;
                  height: 26px;
                  width: 40px;
                  padding: 0;
                  border-radius: 2px;
                  border: none;
                  font-size: 14px;
                  font-weight: 400;
                  color: #747990;
                  background-color: #f7f8fc;
                  &:hover {
                    color: #747990;
                    background-color: #eaebef;
                  }
                  &:focus {
                    color: #747990;
                    background-color: #eaebef;
                  }
                  &:active {
                    color: #747990;
                    background-color: #eaebef;
                  }
                }
                .select {
                  margin-left: 10px;
                  width: 100px;
                }
              }
            }
            .has-criteria-search-area {
              border-top: 1px solid #f7f7fa;
            }
            .company-result-news-list {
              height: 680px;
              overflow: auto;
              .news-item-container {
                padding: 16px 24px;
              }
            }
            .perimeter-result-news-list {
              height: 680px;
              overflow: auto;
              .news-item-container {
                padding: 16px 24px;
              }
            }
          }
        }
        .right {
          float: left;
          width: 376px;
          margin-left: 10px;
          .perimeter-company {
            margin-top: 16px;
          }
          .result-right-content {
            width: 376px;
            top: -276px;
          }
        }
      }
    }
  }
}
/deep/.el-select .el-input__inner {
  height: 26px;
  border: none !important;
  border-radius: 2px;
  color: #464d6c;
  background-color: #f7f8fc !important;
  font-size: 14px;
  &:hover {
    background-color: #eaebef !important;
  }
}
/deep/.el-select .el-input .el-select__caret {
  font-weight: 900;
  color: #747990;
}

/deep/ .news-item-container .news-item-container-title .title-related-news {
  width: 470px !important;
}

.clearfix:after {
  content: '';
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
}
.clearfix {
  zoom: 1;
}
.tab_fix {
  position: fixed;
}
/deep/ .delete-dialog {
  .el-dialog {
    background-color: #ffffff;
    border-radius: 0;
    width: 400px;
    height: 229px;
    position: relative;
    .el-dialog__headerbtn {
      top: 14px;
    }
    .el-dialog__header {
      padding: 0;
      height: 44px;
      width: 100%;
      box-shadow: inset 0px -1px 0px 0px #f7f7fa;
      padding: 0 24px;
      .el-dialog__title {
        color: #171f46;
        font-size: 14px;
        line-height: 44px;
      }
    }
    .el-dialog__body {
      padding: 24px;
      margin-top: 44px;
      color: #747990;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
    }
    .el-dialog__footer {
      width: 100%;
      height: 64px;
      background-color: #ffffff;
      box-shadow: inset 0px 1px 0px 0px #f7f7fa;
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 16px 0;
      .footer-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 136px;
        height: 32px;
        .cancel-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          color: #464d6c;
          background-color: #f7f8fc;
          border-radius: 2px;
          border: none;
        }
        .confirm-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          color: #ffffff;
          background-color: #45a8cc;
          margin-left: 16px;
          border-radius: 2px;
          border: none;
        }
      }
    }
  }
}
</style>
